import useGetSavedSearchWebhooks from "app/pages/sales-intelligence/modules/saved-search-webhooks/query/queries/useGetSavedSearchWebhooks";
import type { ISavedSearchWebhook } from "app/pages/sales-intelligence/modules/saved-search-webhooks/types/webhook";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export interface IFindNewCompaniesData {
    webhooks: ISavedSearchWebhook[] | undefined;
    isEnabled: boolean;
    isFetching: boolean;
    isStale: boolean;
    hasAccess: boolean;
    isConfigured: boolean;
}

const useFindNewCompaniesData = (): IFindNewCompaniesData => {
    const isEnabled = salesSettingsHelper.isSavedSearchWebhooksEnabled;
    const hasAccess = salesSettingsHelper.hasAccessToManageSavedSearchWebhooks;

    const { data: webhooks, isFetching, isStale } = useGetSavedSearchWebhooks();

    const isConfigured = isEnabled && hasAccess && (webhooks?.length ?? 0) > 0;

    return {
        isFetching,
        isStale,
        webhooks,
        isEnabled,
        hasAccess,
        isConfigured,
    };
};

export default useFindNewCompaniesData;
